import * as tslib_1 from "tslib";
import React from 'react';
import { Field as FormikField, FastField as FormikFastField, } from 'formik';
import PropTypes from 'prop-types';
import isNumber from 'lodash/isNumber';
import isNaN from 'lodash/isNaN';
function createField(fast) {
    var _a;
    /**
     * 表单域组件。负责将输入框与`<Form />`进行绑定。
     *
     * @export
     * @class Field
     * @extends {React.Component}
     */
    return _a = /** @class */ (function (_super) {
            tslib_1.__extends(Field, _super);
            // tslint:disable-next-line:no-any
            function Field(props, _a) {
                var setFieldValidate = _a.setFieldValidate;
                var _this = _super.call(this, props) || this;
                _this.validate = _this.validate.bind(_this);
                setFieldValidate(props.name, _this.validate);
                return _this;
            }
            Field.prototype.componentWillUnmount = function () {
                this.context.removeFieldValidate(this.props.name);
            };
            // tslint:disable-next-line:no-any
            Field.prototype.validate = function (value) {
                var _a = this.props, required = _a.required, _b = _a.requireErrorInfo, requireErrorInfo = _b === void 0 ? '必填' : _b, min = _a.min, max = _a.max, maxLength = _a.maxLength, validate = _a.validate, trimRequired = _a.trimRequired;
                if (required &&
                    (!value || (value instanceof Array && value.length === 0))) {
                    return requireErrorInfo;
                }
                if (trimRequired && (!value || value.trim() === '')) {
                    return requireErrorInfo;
                }
                if (isNumber(min) && !isNaN(parseFloat(value)) && value < min) {
                    return "\u8F93\u5165\u503C\u4E0D\u80FD\u5C0F\u4E8E" + min;
                }
                if (isNumber(max) && !isNaN(parseFloat(value)) && max < value) {
                    return "\u8F93\u5165\u503C\u4E0D\u80FD\u5927\u4E8E" + max;
                }
                if (typeof maxLength === 'number' &&
                    typeof value === 'string' &&
                    value.length > maxLength) {
                    return "\u8F93\u5165\u6587\u672C\u4E0D\u80FD\u8D85\u8FC7" + maxLength + "\u5B57";
                }
                var validateResult = validate && validate(value, this.context.sinouiForm.getFormContext());
                if (validateResult) {
                    return validateResult;
                }
                return undefined;
            };
            Field.prototype.render = function () {
                var _a = this.props, required = _a.required, min = _a.min, max = _a.max, maxLength = _a.maxLength, validate = _a.validate, value = _a.value, props = tslib_1.__rest(_a, ["required", "min", "max", "maxLength", "validate", "value"]);
                var FieldComponent = fast ? FormikFastField : FormikField;
                return (React.createElement(FieldComponent, tslib_1.__assign({}, props, { value: value, validate: this.validate })));
            };
            return Field;
        }(React.Component)),
        _a.contextTypes = {
            setFieldValidate: PropTypes.func,
            removeFieldValidate: PropTypes.func,
            sinouiForm: PropTypes.object,
        },
        _a;
}
var Field = createField(false);
var FastField = createField(true);
export default Field;
export { FastField };
//# sourceMappingURL=Field.js.map